import I18n from "common/i18n";
import { ProfileRow } from "./ProfileRow";
import {
  ACCESSORY_OPTIONS,
  HAIRSTYLE_OPTIONS,
  BODY_TYPE_OPTIONS,
  FACE_SHAPE_OPTIONS,
} from "../constants";

type AppearanceEditField = "accessory" | "hairstyle" | "bodyType" | "faceShape";

type ProfileAppearanceTabProps = {
  accessory: string[];
  hairstyle: string;
  bodyType: string;
  faceShape: string;
  onOpenEditModal: (field: AppearanceEditField) => void;
};

const renderMultiValues = (values: string[], options: Array<{ key: string; labelKey: string }>) => {
  if (values.length === 0) {
    return (
      <span className="type-body text-textcolor-black/50 block w-[400px]">
        {I18n.t("MSG_PROFILE_NOT_SET")}
      </span>
    );
  }
  const labels = values
    .map((v) => {
      const option = options.find((o) => o.key === v);
      return option ? I18n.t(option.labelKey) : v;
    })
    .join(", ");
  return <span className="type-body text-textcolor-black block w-[400px] truncate">{labels}</span>;
};

const renderSingleValue = (value: string, options: Array<{ key: string; labelKey: string }>) => {
  if (!value) {
    return (
      <span className="type-body text-textcolor-black/50 block w-[400px]">
        {I18n.t("MSG_PROFILE_NOT_SET")}
      </span>
    );
  }
  const option = options.find((o) => o.key === value);
  return (
    <span className="type-body text-textcolor-black block w-[400px] truncate">
      {option ? I18n.t(option.labelKey) : value}
    </span>
  );
};

export const ProfileAppearanceTab = ({
  accessory,
  hairstyle,
  bodyType,
  faceShape,
  onOpenEditModal,
}: ProfileAppearanceTabProps) => (
  <div className="flex-col-el items-center w-full max-w-[900px] gap-4 px-4">
    <ProfileRow
      label={I18n.t("MSG_PROFILE_AI_ACCESSORY")}
      content={renderMultiValues(accessory, ACCESSORY_OPTIONS)}
      onEdit={() => onOpenEditModal("accessory")}
    />
    <ProfileRow
      label={I18n.t("MSG_PROFILE_AI_HAIRSTYLE")}
      content={renderSingleValue(hairstyle, HAIRSTYLE_OPTIONS)}
      onEdit={() => onOpenEditModal("hairstyle")}
    />
    <ProfileRow
      label={I18n.t("MSG_PROFILE_AI_BODY_TYPE")}
      content={renderSingleValue(bodyType, BODY_TYPE_OPTIONS)}
      onEdit={() => onOpenEditModal("bodyType")}
    />
    <ProfileRow
      label={I18n.t("MSG_PROFILE_AI_FACE_SHAPE")}
      content={renderSingleValue(faceShape, FACE_SHAPE_OPTIONS)}
      onEdit={() => onOpenEditModal("faceShape")}
    />
  </div>
);
